<section *ngFor="let status of statesToDisplay"
         class="status-group">
  <header>
    <app-action-status-icon [icon]="status"></app-action-status-icon>
    <h5 class="title">{{ ('statusTitle'+status) | translate }}</h5>
    <svg-icon src="assets/images/generic/Info.svg"
              [mdbTooltip]="tooltipView"
              placement="left"></svg-icon>
    <ng-template #tooltipView>
      <span [innerHTML]="('buildingActionsHeaderStateTooltip' + status) | translate"></span>
    </ng-template>
  </header>
  <main class="actions">
    <ng-container *ngIf="(actionsWith(status) | async) as actions">
      <ng-container *ngIf="actions.length; else noJobsForStatusView">

        <app-draggable-action *ngFor="let action of actions"
                              [model]="action"
                              (click)="openJobDialog(action)"></app-draggable-action>
      </ng-container>

      <ng-template #noJobsForStatusView>
        <p class="padded empty-state">{{ 'empty'+status+'JobsColumnMessage' | translate }}</p>
      </ng-template>

    </ng-container>
  </main>
</section>

<div class=" page-spinner
            " *ngIf="loading">
  <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
</div>
